<app-tablepage-base [loading]="loading">

  <!-- 1. LA TABELLA (Dichiarata semplicemente con scrollHeight="100%") -->
  <p-table [value]="services"
           [paginator]="true" [rows]="25"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['serviceId', 'name']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">{{ 'titles.listServices' | translate }}</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{ 'search' | translate }}..." />
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th style="width:10%">ID</th>
        <th style="width:10%">{{ 'code' | translate }}</th>
        <th>{{ 'description' | translate }}</th>
        <th style="width:10%"></th>
      </tr>
    </ng-template>
    <ng-template #body let-service>
      <tr [pSelectableRow]="service">
        <td>{{ service.serviceId }}</td>
        <td>{{ service.name }}</td>
        <td>{{ service.description }}</td>
        <td>
          <p-button icon="pi pi-user-edit" (click)="onShowDialog(service)" />
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- 2. DIALOG (Posizionata fuori dal flusso, non rompe il layout) -->
  <app-service-dialog [messageService]="messageService"
                      [(visible)]="showDialog"
                      [service]="selectedService"
                      (saved)="onServiceSaved($event)">
  </app-service-dialog>

</app-tablepage-base>
